import { connectAppStore } from "../../../../../Store/AppStore";
import PageDependencies from "../../../../../Feature/PageDependencies";
import ConditionerDataTable from "./ConditionerDataTable"

const HeatingModule = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        htmlToReactParse,
        tryCatchFinally,
        layoutManager,
        getData,
        guid,
        useReducerSmart,
        toastPrint,
        useParams,
        BindedInput,
        BindedSelect,
        useRef,
        BindedRadio,
        getAppStore,
        pageProfile,
        AppLoading,
        loaModelFromApi,
        FormValidate,
        dataExtension,
        DropDragDataTable,
        OnDragEndOperation,
        DragDropContext,
    } = PageDependencies();
    let debug = layoutManager.Layout_GetDebugModel(props);
    const defaultParams = pageProfile.getDefaultParams(useParams());
    const [init, setInit] = useState(false);
    const defaultViewModel = {
        ...defaultParams,
    };
    const [extraPostModel, setExtraPostModel] = useState({
        ...defaultParams
      });
    const buttonWidthRef = useRef();
    const [selectedIds, setSelectedIds] = useState({});
    const [buttonText, setButtonText] = useState("Add");
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart(defaultViewModel);
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [appStoreState, appStoreDispatch] = getAppStore(props);
    const getUrl = "api/NewHome/CoolingModule/Accessor/Get";
    const validateMethodsAdd = {
        appliedZones: (value) => { 
            return FormValidate.validateTextRequired(value, "Applied zones", undefined, true);
        },
    };
    const formValidateAdd = new FormValidate(useState(validateMethodsAdd), useState(), useState(), useState(), false);
    const validateMethodsCalculate = {
        starRating: (value, newViewModel) => { 
                const conditionerTypeId = parseInt(newViewModel.conditionerTypeId);
                if (conditionerTypeId >= 2 && conditionerTypeId <= 3) {
                    return FormValidate.validateNumberBetween(value, "Star rating", 0 , 10);
                } else if (conditionerTypeId >= 4 && conditionerTypeId <= 10) {
                    return FormValidate.validateNumberBetween(value, "Star rating", 1 , 10);
                }
                return "";
            },
        capacity: (value, newViewModel) => { 
                const conditionerTypeId = parseInt(newViewModel.conditionerTypeId);
                if ( conditionerTypeId === 10 || conditionerTypeId === 11 || conditionerTypeId === 12 || conditionerTypeId === 13) {
                    return "";
                }
                if(newViewModel.calculationModel !== "StarRatingOnly" && conditionerTypeId != 1){              
                    return FormValidate.validateNumberGreaterThan0(value, "Capacity");
                } 
                return "";
            },
        };
    const formValidateCalculate = new FormValidate(useState(validateMethodsCalculate), useState(), useState(), useState(), false);
    //conditioner table
    const [conditionerData, setConditionerData] = useState([]);
    //drag table
    const [allZonesData, setAllZonesData ] = useState([]);
    const [availableZonesData, setAvailableZonesData ] = useState([]);
    const [appliedZonesData, setAppliedZonesData ] = useState([]);
    const draggableTablesDic = {};
    const table1Id = "Cooling_AvailableZones_21d36a29-d6f0-4a6d-9b0e-2f1380241bb1";
    const table2Id = "Cooling_AppliedZones_21d36a29-d6f0-4a6d-9b0e-2f1380241bb1";
    draggableTablesDic[table1Id] = { data: availableZonesData, setData: setAvailableZonesData };
    draggableTablesDic[table2Id] = { data: appliedZonesData, setData: setAppliedZonesData };
    const columnsZone = [
        { name: "name", text: "Name", width: "100%" }
      ];
    //form
    const [canSubmit, setCanSubmit] = useState(false);
    const [reloadForm, setReloadForm] = useState("");
    const [pageLayout, setPageLayout] = useState({showCop: true, showHspf: true, disabledEER: true, disabledHspf: true, showStarRating: false, showCapacity: false});

    const getAvailableZones = (viewModel) => {
        if(viewModel.existingConditionersNewHome === undefined){
            return [];
        }
        const allZones = viewModel.allZones;
        let existingConditionedZones = dataExtension.selectMany(viewModel.existingConditionersNewHome.map(c=>c.appliedZoneIds));
        existingConditionedZones = dataExtension.distinct(existingConditionedZones);
        let newAvailableZones = [];
        for(let i =0; i < allZones.length; i++){
            const zone = allZones[i];
            if(!existingConditionedZones.includes(zone.id)){
                newAvailableZones.push(zone)
            }
        }
        return newAvailableZones;
    }

    useEffect(()=>{
        layoutManager.Layout_Headter_Footer_SideBar(props);
        loaModelFromApi.loadDefault(true, getUrl, viewModel, dispatchViewModel, setLoading, "Loading cooling module", appStoreDispatch, (newViewModel)=>{
            const allZones = newViewModel.allZones;
            setAvailableZonesData(getAvailableZones(newViewModel));
            setAllZonesData(allZones);
        }, setInit);
    },[]);

    useEffect(()=>{
        if (reloadForm === "") return;

        const timer = setTimeout(()=>{
            window.location.reload();
        },1500);
        return () => {
            clearTimeout(timer);
        };
    },[reloadForm])

    useEffect(()=>{
        const newViewModel = {...viewModel, appliedZones: appliedZonesData};
        dispatchViewModel(newViewModel);
    }, [appliedZonesData]);

    useEffect(()=>{
        setCanSubmit(false);
        const selectedConditioner =  dataExtension.getSelectOptionByValue(viewModel.conditionerTypes, viewModel.conditionerTypeId);
        if(selectedConditioner !== undefined){
            //default
            if(parseInt(selectedConditioner.value) == 1){
                setPageLayout({...pageLayout, showStarRating: false, showHspf: true, disabledHspf: true, disabledEER: true});
            }else if(parseInt(selectedConditioner.value) >= 10){
            //evaporative
                setPageLayout({...pageLayout, showStarRating: false, showHspf: false, disabledEER: false});
            }else{
            //rest
                setPageLayout({...pageLayout, showStarRating: true, showHspf: true, disabledHspf: false, disabledEER: false});
            }
         
            //set eer
            if(selectedIds.selectedItemIds !== undefined && selectedIds.selectedItemIds.length === 1){
                const selectedConditionerName = selectedConditioner.description;
                const conditionerId = selectedIds.selectedItemIds[0];
                let conditioner = {};
                for(let i = 0; i < viewModel.existingConditionersNewHome.length; i++){
                    if(viewModel.existingConditionersNewHome[i].id == conditionerId){
                        conditioner = viewModel.existingConditionersNewHome[i];
                    }
                }      
                const existingConditionerName = conditioner.conditionerName;
                if(selectedConditionerName !== existingConditionerName){
                    dispatchViewModel({...viewModel, eerOrCop: selectedConditioner.eerOrCop});
                }
            }    
        }   
    }, [viewModel.conditionerTypeId, viewModel.starRating, viewModel.capacity, viewModel.calculationModel]);

    const applyAllClick = () => {
        const newZones = dataExtension.distinctBy([...appliedZonesData, ...getAvailableZones(viewModel)],"id");
        setAvailableZonesData([]);
        setAppliedZonesData(newZones);
    }

    const resetClick = () =>{
        const newZones = dataExtension.distinctBy([...appliedZonesData, ...getAvailableZones(viewModel)],"id");
        setAvailableZonesData(newZones);
        setAppliedZonesData([]);
    }

    const calculationCOPHSPF = async ()=>{
        formValidateCalculate.setValidateVisibility(true);
        const validateResult = formValidateCalculate.checkValidateResult(viewModel);
        if(!validateResult) return;
        const calculateUrl = "api/NewHome/CoolingModule/Accessor/CalculateCoolerEerAndTcspf";
        setLoading({ isLoading: true, text: "Calculating" });
 
        tryCatchFinally.syncProcess(async()=>{
            const response = await getData.processPost(true, calculateUrl, viewModel);
            if(!response.state){
                toastPrint.printErrorMessage(response.message);
            }else{
                const newModel = response.viewModel;
                dispatchViewModel({...viewModel, eerOrCop: Math.round(newModel.eerOrCop * 100) / 100, tcspf: Math.round(newModel.tcspf * 100) / 100, maxTcspf: Math.round(newModel.maxTcspf * 100) / 100}, ()=>{
                    setCanSubmit(true);
                });
            }
        }, setLoading);
    }

    useEffect(()=>{
        if (viewModel.existingConditionersNewHome === undefined || viewModel.existingConditionersNewHome === null) return;
        const timer = setTimeout(()=>{
            tryCatchFinally.syncProcess(()=>{
                if(selectedIds !== undefined){
                    const ids = selectedIds.selectedItemIds;
                    if(ids !== undefined && ids.length === 1){
                        setButtonText("Update");
                        //load conditioner
                        const conditionerId = ids[0];
                        let conditioner = {};
                        for(let i = 0; i < viewModel.existingConditionersNewHome.length; i++){
                            if(viewModel.existingConditionersNewHome[i].id == conditionerId){
                                conditioner = viewModel.existingConditionersNewHome[i];
                            }
                        }
                        let appliedZoneIds = [];
                        if (viewModel.existingConditionersNewHome.length > 0) {
                            appliedZoneIds = conditioner.appliedZoneIds;
                        }
                        const newAvailableZonesData = [];
                        const newAppliedZonesData = [];
                        for(let i = 0; i< allZonesData.length; i++){
                            const zone = allZonesData[i];
                            let push = false;
                            for(let j = 0; j< appliedZoneIds.length; j++){
                                if(appliedZoneIds[j] == zone.id){
                                    newAppliedZonesData.push(zone);
                                    push = true;
                                }
                            }
                            if(!push){
                                newAvailableZonesData.push(zone);
                            }
                        }          
                        const loadModel = {...viewModel, 
                            conditionerTypeId: conditioner.index,
                            capacity: conditioner.capacity,
                            starRating: conditioner.starRating,
                            eerOrCop: Math.round(conditioner.eer * 100) / 100,
                            tcspf: Math.round(conditioner.tcspf * 100) / 100,
                            calculationModel: conditioner.starRatingCheck === true ? "StarRatingOnly" : "CapacityOnly",
                            id: conditioner.id,
                            appliedZones:newAppliedZonesData
                        };
                        dispatchViewModel(loadModel, ()=>{
                            setAvailableZonesData(getAvailableZones(viewModel));
                            setAppliedZonesData(newAppliedZonesData);
                        });
                    }else{
                        setButtonText("Add");
                        const loadModel = {...viewModel, 
                            capacity: 0,
                            starRating: 0,
                            tcspf: 0,
                            eerOrCop: 0,
                            calculationModel:"StarRatingOnly",
                            id: guid.emptyGuid()
                        };
                        dispatchViewModel(loadModel, ()=>{
                            setAppliedZonesData([]);
                            setAvailableZonesData(getAvailableZones(viewModel));
                        });                    
                    }
                }
            });
        }, 850);
        return () => {
            clearTimeout(timer);
          };
    }, [selectedIds]);

    const submit = async()=>{
        formValidateAdd.setValidateVisibility(true);
        const validateResult = formValidateAdd.checkValidateResult(viewModel);
        if(!validateResult) return;
        const postUrl = "api/NewHome/CoolingModule/Accessor/" + buttonText + "CoolingConditioner";
        
        await tryCatchFinally.asyncProcess(async()=>{
            setLoading({ isLoading: true, text: "Processing cooling device" });
            const response = await getData.processPost(true, postUrl, viewModel);
            toastPrint.printResponse(response);
            resetClick();
            setReloadForm(guid.newGuid());
        });
    }

    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <div className="app-main__inner">
                <div className="app-page-title">
                    <div className="page-title-wrapper">
                        <div className="page-title-heading">
                            <div className="page-title-icon">
                                <i className="pe-7s-angle-down-circle icon-gradient bg-tempting-azure">
                                </i>
                            </div>
                            <div>
                                Cooling
                                <div className="page-title-subheading">
                                    {pageProfile.getPageSubTitle(appStoreState)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {init === true &&
                    <>
             <div className="main-card mb-3 card">
                    <div className="card-header">
                        <button type="button" data-toggle="collapse" data-target="#AnnualEnergyConsumptionDiv" aria-expanded="true" aria-controls="AnnualEnergyConsumptionDiv" className="text-left m-0 p-0 btn btn-block">
                            <h5 className="m-0 p-0 card-title">Annual Energy Consumption</h5>
                        </button>
                    </div>
                    <div data-parent="#AnnualEnergyConsumptionAccordion" id="AnnualEnergyConsumptionDiv" className="collapse show">
                        <div className="card-body">
                            <div className="separator"></div>
                            <div className="form-row row">
                                <div className="col-3">
                                    <div className="position-relative form-group">
                                        <label>ZERL Zone: <span style={{color:"red"}}>{viewModel.zerlZone}</span></label>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="position-relative form-group">
                                        <label>Evaporative Cooler: <span style={{color:"red"}}>{viewModel.evaporativeCoolerSuitability}</span></label>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="position-relative form-group">
                                        <label>Electricity (kWh/yr): {parseFloat(viewModel.annualElectricityEnergy).toFixed(2)}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row row">
                                <div className="col-3">
                                    <div className="position-relative form-group">
                                            <label>CO<sub>2</sub> -e Emissions (kg/yr): {parseFloat(viewModel.annualEnergyCo2).toFixed(2)}</label>
                                        </div>
                                </div>
                                <div className="col-3">
                                    <div className="position-relative form-group">
                                        <label>Societal Cost (AUD/yr): {parseFloat(viewModel.annualEnergyCost).toFixed(2)}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div className="card-header">
                        <button type="button" data-toggle="collapse" data-target="#HeatingConditionersListDiv" aria-expanded="true" aria-controls="HeatingConditionersListDiv" className="text-left m-0 p-0 btn btn-block">
                            <h5 className="m-0 p-0 card-title">Applied Appliances</h5>
                        </button>
                    </div>
                    <div data-parent="#HeatingConditionersList" id="HeatingConditionersListDiv" className="collapse show">
                        <div className="card-body">
                            {debug && <p>{JSON.stringify(conditionerData)}</p>}
                            <ConditionerDataTable
                                debug = {debug}
                                data = {conditionerData}
                                setData = {setConditionerData}
                                extraPostModel = {extraPostModel}
                                url="api/NewHome/CoolingModule/Accessor"
                                conditionerType="Cooling"
                                tableReload = {reloadForm}
                                setTableReload = {setReloadForm}
                                selectedIds = {selectedIds}
                                setSelectedIds = {setSelectedIds}
                                setLoading = {setLoading}
                            ></ConditionerDataTable>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
        <div className="card-header">
            <button type="button" data-toggle="collapse" data-target="" aria-expanded="true" aria-controls="" className="text-left m-0 p-0 btn btn-block">
                <h5 className="m-0 p-0 card-title">Cooling Appliance</h5>
            </button>
        </div>
        <div data-parent="#HeatingAccordion" id="HeatingCollapsibleDiv" className="collapse show">
            <div className="card-body">
                <div className="form-row row">
                    <div className="col-lg-6 col-6">
                        <div className="position-relative form-group pr-3">
                            <BindedSelect
                                className="form-control"
                                id="ConditionerTypeId"
                                name="ConditionerTypeId"
                                binding={[viewModel, "conditionerTypeId", bindingViewModel]}
                                options={"conditionerTypes"}
                            ></BindedSelect>
                        </div>
                    </div>
                </div>
                <div className="form-row-separator"></div>
                <div className="form-row row">
                    {pageLayout.showStarRating && 
                        <div className="col-12">
                            <div className="position-relative form-group pr-3">
                                <div className="form-row row">
                                    <div className="col-lg-2 col-2 form-check" style={{marginTop:"10px", marginLeft:"15px"}}>
                                        <BindedRadio
                                            id="StarRatingOnly"
                                            buttonValue = "StarRatingOnly"
                                            buttonLabel = "Star Rating Only"
                                            binding={[viewModel, "calculationModel", bindingViewModel]}
                                        ></BindedRadio>
                                    </div>
                                    <div className="col-lg-2 col-2">
                                        <BindedSelect
                                            className="form-control"
                                            binding={[viewModel, "starRating", bindingViewModel]}
                                            id="StarRating"
                                            name="StarRating"
                                            options={
                                                [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10].map((m)=>{return  {text: m, value: m};})
                                            }
                                            validate = {formValidateCalculate}
                                        ></BindedSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {pageLayout.showCapacity &&
                        <div className="col-12">
                            <div className="position-relative form-group pr-3">
                                <div className="form-row row">
                                    <div style={{marginLeft:"15px"}} className="col-lg-2 col-2 form-check">
                                        <BindedRadio
                                            id="CapacityOnly"
                                            buttonValue = "CapacityOnly"
                                            buttonLabel = "Capacity (KW)"
                                            binding={[viewModel, "calculationModel", bindingViewModel]}
                                        ></BindedRadio>              
                                    </div>
                                    {viewModel.calculationModel === "CapacityOnly" &&
                                    <div className="col-lg-2 col-2">
                                        <BindedInput
                                            className="form-control"
                                            binding={[viewModel, "capacity", bindingViewModel]}
                                            id="Capacity"
                                            name="Capacity"
                                            type="number" 
                                            step="0.5" 
                                            validate = {formValidateCalculate}
                                        ></BindedInput>
                                    </div>
                                    }                              
                                </div>
                            </div>
                        </div>
                    }

                </div>
                <div className="form-row row">
                    <div className="col-2">
                        <div className="position-relative form-group">
                            <label htmlFor="EerOrCop">EER</label>
                            <BindedInput
                                className="form-control"
                                    disabled ={pageLayout.disabledEER}
                                binding={[viewModel, "eerOrCop", bindingViewModel]}
                                id="EerOrCop"
                                name="EerOrCop"
                                type="number" 
                                step="0.1" 
                            ></BindedInput>
                        </div>
                    </div>
                    {pageLayout.showHspf && 
                        <div className="col-2">
                            <div className="position-relative form-group">
                                <label htmlFor="TCSPF" >TCSPF</label>
                                <BindedInput
                                    className="form-control"
                                    disabled ={pageLayout.disabledHspf}
                                    binding={[viewModel, "tcspf", bindingViewModel]}
                                    id="TCSPF"
                                    name="TCSPF"
                                    type="number" 
                                    step="0.1" 
                                ></BindedInput>
                                {canSubmit && viewModel.tcspf > viewModel.maxTcspf && (viewModel.conditionerTypeId == "2" || viewModel.conditionerTypeId == "3") && 
                                <p style={{color: 'red', marginTop: "10px"}}> The claimed efficiency may be beyond that currently available on the market</p>}
                            </div>     
                        </div>
                    }
                    <div className="col-3">
                        <div className="position-relative form-group">
                            <label style={{color:"red"}}> {!canSubmit && "Calculation EER or TCSPF before submiting" } {canSubmit && htmlToReactParse("&nbsp;") }</label>
                            <a type="button" className="btn btn-primary form-control" onClick={calculationCOPHSPF}>Calculation EER/TCSPF</a>
                        </div>                   
                    </div>
                </div>
                <div className="divider"></div>         
                <DragDropContext onDragEnd={(result) => OnDragEndOperation(result, draggableTablesDic)} >
                    <div className="form-row row">
                        <div className="col-4">
                            <p>Available Zones</p> 
                            <DropDragDataTable   
                                style={{maxHeight:"300px", overflowY:"scroll"}}                   
                                columns={columnsZone}
                                id={table1Id}
                                data={availableZonesData}
                                setData={setAvailableZonesData}
                                noRecordsMessage="No zones"
                            ></DropDragDataTable>                          
                        </div>
                        <div className="col-3" align="center">
                            <div className="row" display="inline-block">
                                <p>Zones operation</p> 
                                <p><button type="button" className="btn btn-primary" ref={buttonWidthRef} onClick={applyAllClick}>Apply All</button></p> 
                                <p><button type="button" className="btn btn-primary" style={{width: buttonWidthRef.current === undefined || buttonWidthRef.current === null ? -1 : buttonWidthRef.current.clientWidth}} onClick={resetClick}>Reset</button></p> 
                            </div>
                            <BindedInput
                                hidden
                                className="form-control"
                                binding={[viewModel, "appliedZones", bindingViewModel]}
                                id="AppliedZones"
                                name="AppliedZones"
                                validate = {formValidateAdd}
                            ></BindedInput>
                        </div>
                        <div className="col-4">
                            <p>Applied Zones</p>
                            <DropDragDataTable
                                style={{maxHeight:"300px", overflowY:"scroll"}}        
                                columns={columnsZone}
                                id={table2Id}
                                data={appliedZonesData}
                                setData={setAppliedZonesData}
                                noRecordsMessage="No zones"
                            ></DropDragDataTable>   
                             <button type="button" style={{marginTop:"10px"}} className="btn btn-primary" disabled={!canSubmit} onClick={submit}>{buttonText} appliance to applied zones</button>
                        </div>
                    </div>
                </DragDropContext>          
            </div>
        </div>
        </div>
            </>
            }
   
        </div>
    </Fragment>
    );
}
export default connectAppStore(HeatingModule);